import React from 'react';
import { Users, CheckCircle, Clock, XCircle } from 'lucide-react';

const teamMembers = [
  {
    id: 1,
    name: 'Sarah Johnson',
    role: 'Proposal Manager',
    avatar: 'https://ui-avatars.com/api/?name=Sarah+Johnson',
    metrics: {
      proposals: 12,
      winRate: 75,
      inProgress: 3,
    },
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Technical Writer',
    avatar: 'https://ui-avatars.com/api/?name=Michael+Chen',
    metrics: {
      proposals: 8,
      winRate: 62,
      inProgress: 2,
    },
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    role: 'Compliance Specialist',
    avatar: 'https://ui-avatars.com/api/?name=Emily+Rodriguez',
    metrics: {
      proposals: 15,
      winRate: 80,
      inProgress: 4,
    },
  },
];

export function TeamPerformance() {
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-medium text-gray-900">Team Performance</h2>
          <p className="text-sm text-gray-500">Performance metrics for active team members</p>
        </div>
        <div className="flex items-center space-x-2">
          <Users className="h-5 w-5 text-gray-400" />
          <span className="text-sm font-medium text-gray-900">{teamMembers.length} members</span>
        </div>
      </div>

      <div className="mt-6 space-y-6">
        {teamMembers.map((member) => (
          <div key={member.id} className="flex items-start space-x-4">
            <img
              src={member.avatar}
              alt={member.name}
              className="h-10 w-10 rounded-full"
            />
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium text-gray-900">{member.name}</h3>
                  <p className="text-sm text-gray-500">{member.role}</p>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="text-center">
                    <p className="text-sm font-medium text-gray-900">{member.metrics.proposals}</p>
                    <p className="text-xs text-gray-500">Proposals</p>
                  </div>
                  <div className="text-center">
                    <p className="text-sm font-medium text-gray-900">{member.metrics.winRate}%</p>
                    <p className="text-xs text-gray-500">Win Rate</p>
                  </div>
                  <div className="text-center">
                    <p className="text-sm font-medium text-gray-900">{member.metrics.inProgress}</p>
                    <p className="text-xs text-gray-500">In Progress</p>
                  </div>
                </div>
              </div>
              <div className="mt-2">
                <div className="flex space-x-2">
                  <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                    <CheckCircle className="mr-1 h-3 w-3" />
                    {member.metrics.proposals - member.metrics.inProgress} Complete
                  </span>
                  <span className="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800">
                    <Clock className="mr-1 h-3 w-3" />
                    {member.metrics.inProgress} Active
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}